module.exports = __webpack_public_path__ + "static/media/payroll_details.3db3ca38.png";